<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { CHECK_LOGIN_STATUS, REFRESH_USER_INFO } from '@/store/modules/op_user'

export default {
  name: 'App',
  computed: {
    ...mapState('opUser', [
      'loginStatus'
    ])
  },
  methods: {
    ...mapMutations('opUser', [
      CHECK_LOGIN_STATUS,
      REFRESH_USER_INFO
    ])
  },
  created () {
    this.checkLoginStatus()

    if (this.loginStatus) {
      this.refreshUserInfo()
      if (this.$route.name === 'Login') {
        this.$router.push({
          name: 'Welcome'
        })
      }
    } else {
      this.$router.push({
        name: 'Login'
      })
      if (this.$route.name !== 'Login') {
        this.$router.push({
          name: 'Login'
        })
        // this.$message({
        //   type: 'error',
        //   message: '登录状态已过期，请重新登录'
        // })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./assets/sass/base";

body {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  color: $primaryTextColor;
}
</style>



// WEBPACK FOOTER //
// src/App.vue